// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Live Training — bright (light) view mode.
 * Aligns page chrome, panels, and typography with global bright UI tokens
 * and the table-setup / coach-table light styles.
 */

html.light-mode.lt-immersive body,
html[data-theme="light"].lt-immersive body {
  background: var(--bg-color, #f3f4f6) !important;
}

.light-mode .lt-page,
html[data-theme="light"] .lt-page {
  --lt-fg: var(--text-color, #0f172a);
  --lt-fg-muted: var(--text-secondary, #475569);
  --lt-panel: var(--surface-color, #ffffff);
  --lt-panel-border: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, #cbd5e1);
  --lt-glass: rgba(255, 255, 255, 0.88);
  --lt-chip-bg: #f1f5f9;
  --lt-chip-border: rgba(15, 23, 42, 0.12);
  background: linear-gradient(
    165deg,
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 8%, var(--bg-color, #f8fafc)) 0%,
    var(--bg-color, #f1f5f9) 42%,
    #ffffff 100%
  );
  color: var(--lt-fg);
}

.light-mode .lt-page__body,
.light-mode .lt-page__main,
html[data-theme="light"] .lt-page__body,
html[data-theme="light"] .lt-page__main {
  color: var(--lt-fg, #0f172a);
}

/* ── Header / progress ─────────────────────────────────────────────────── */

.light-mode .lt-header__title,
.light-mode .lt-header__sub,
.light-mode .lt-club-logo-wrap__name {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-header__sub {
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-header__home-btn,
.light-mode .lt-header__dashboard-btn,
.light-mode .lt-header__icon-btn {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-progress__meta,
.light-mode .lt-progress__seg-label {
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-progress__plan-btn {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-progress__track {
  background: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-progress__seg,
.light-mode .lt-progress__seg--named {
  background: rgba(15, 23, 42, 0.08);
  border-color: transparent;
}

.light-mode .lt-station-tabs__btn {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-station-tabs__btn--selected {
  color: #fff;
}

/* ── Waiting / empty / hero ────────────────────────────────────────────── */

.light-mode .lt-waiting__title,
.light-mode .lt-waiting__countdown-value,
.light-mode .lt-waiting__table-num,
.light-mode .lt-coach-empty__title,
.light-mode .lt-coach-empty__countdown-value,
.light-mode .lt-hero__timer-value,
.light-mode .lt-hero__name,
.light-mode .lt-hero__number,
.light-mode .lt-hero__exercise-remaining-value {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-waiting__hint,
.light-mode .lt-waiting__countdown,
.light-mode .lt-coach-empty__hint,
.light-mode .lt-coach-empty__countdown-label,
.light-mode .lt-hero__timer-state,
.light-mode .lt-hero__schema,
.light-mode .lt-hero__exercise-remaining-label,
.light-mode .lt-hero__matchup,
.light-mode .lt-hero__table {
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-coach-empty__countdown {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));
}

.light-mode .lt-coach-empty__btn--secondary,
.light-mode .lt-coach-empty__btn--ghost {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-waiting__table-card,
.light-mode .lt-hero__seq-banner,
.light-mode .lt-hero__exercise-remaining {
  background: var(--lt-panel, #fff);
  border: 1px solid var(--lt-panel-border, #cbd5e1);
  color: var(--lt-fg, #0f172a);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.light-mode .lt-hero__seq-pill {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-hero__ring-bg {
  stroke: rgba(15, 23, 42, 0.12);
}

.light-mode .lt-fs-gate {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-mobile-only {
  background: rgba(255, 255, 255, 0.92);
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-mobile-only__title {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-mobile-only__copy {
  color: var(--lt-fg-muted, #475569);
}

/* ── Player view ───────────────────────────────────────────────────────── */

.light-mode .lt-pv,
html[data-theme="light"] .lt-pv {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-pv__chrome,
html[data-theme="light"] .lt-pv__chrome {
  border-bottom-color: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-pv__player-name,
.light-mode .lt-pv__id-name,
.light-mode .lt-pv__table-hero-number,
.light-mode .lt-pv__table-roster-name,
.light-mode .lt-pv__timer-value,
.light-mode .lt-pv__side-chip,
.light-mode .lt-pv__side-name,
.light-mode .lt-pv__ls-wait-header-title,
.light-mode .lt-pv__wait-exercise,
.light-mode .lt-pv__table-center-number,
html[data-theme="light"] .lt-pv__player-name,
html[data-theme="light"] .lt-pv__id-name,
html[data-theme="light"] .lt-pv__table-hero-number,
html[data-theme="light"] .lt-pv__table-roster-name,
html[data-theme="light"] .lt-pv__timer-value,
html[data-theme="light"] .lt-pv__side-chip,
html[data-theme="light"] .lt-pv__side-name,
html[data-theme="light"] .lt-pv__ls-wait-header-title,
html[data-theme="light"] .lt-pv__wait-exercise,
html[data-theme="light"] .lt-pv__table-center-number {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-pv__table-line,
.light-mode .lt-pv__table-hero-label,
.light-mode .lt-pv__table-roster-title,
.light-mode .lt-pv__personalized-cue,
.light-mode .lt-pv__timer-label,
.light-mode .lt-pv__wait-type,
.light-mode .lt-pv__wait-subtype,
.light-mode .lt-pv__side-stats,
.light-mode .lt-pv__table-center-label,
html[data-theme="light"] .lt-pv__table-line,
html[data-theme="light"] .lt-pv__table-hero-label,
html[data-theme="light"] .lt-pv__table-roster-title,
html[data-theme="light"] .lt-pv__personalized-cue,
html[data-theme="light"] .lt-pv__timer-label,
html[data-theme="light"] .lt-pv__wait-type,
html[data-theme="light"] .lt-pv__wait-subtype,
html[data-theme="light"] .lt-pv__side-stats,
html[data-theme="light"] .lt-pv__table-center-label {
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-pv__side-letter,
html[data-theme="light"] .lt-pv__side-letter {
  color: rgba(15, 23, 42, 0.38);
}

.light-mode .lt-pv__wait-card,
.light-mode .lt-pv__table-panel {
  background: var(--lt-panel, #fff);
  border-color: var(--lt-panel-border, #cbd5e1);
  color: var(--lt-fg, #0f172a);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.light-mode .lt-pv__id-bar {
  border-bottom-color: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-pv__hr-chip,
.light-mode .lt-panel-mode-toggle {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-pv__side-chip {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);
  color: var(--lt-brand, #0877bc);
}

.light-mode .lt-pv__table-roster-item {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.1));
}

.light-mode .lt-pv__table-roster-item--viewer {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 30%, #cbd5e1);
}

.light-mode .lt-pv__role--active,
html[data-theme="light"] .lt-pv__role--active,
.light-mode .lt-lsp__role--active,
html[data-theme="light"] .lt-lsp__role--active {
  background: rgba(34, 179, 92, 0.12);
  color: #15803d;
  border-color: rgba(34, 179, 92, 0.35);
}

.light-mode .lt-pv__role--sparring,
html[data-theme="light"] .lt-pv__role--sparring,
.light-mode .lt-lsp__role--sparring,
html[data-theme="light"] .lt-lsp__role--sparring {
  background: rgba(243, 140, 41, 0.12);
  color: #c2410c;
  border-color: rgba(243, 140, 41, 0.35);
}

/* ── Coach dashboard ───────────────────────────────────────────────────── */

.light-mode .lt-coach-dash {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-coach-dash__toolbar {
  background: var(--lt-glass, rgba(255, 255, 255, 0.92));
  border-color: var(--lt-panel-border, #cbd5e1);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.light-mode .lt-coach-dash__stat,
.light-mode .lt-coach-dash__chrono-btn {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-coach-dash__chrono-btn {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);
}

.light-mode .lt-coach-dash__chrono-btn:hover,
.light-mode .lt-coach-dash__chrono-btn--active {
  background: var(--lt-brand, #0877bc);
  color: #fff;
  border-color: var(--lt-brand, #0877bc);
}

.light-mode .lt-coach-dash__tables-btn,
.light-mode .lt-coach-dash__setup-icon-btn {
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 12%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, #cbd5e1);
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-coach-dash__tables-btn svg,
.light-mode .lt-coach-dash__setup-icon-btn {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-coach-dash__tables-btn:hover,
.light-mode .lt-coach-dash__setup-icon-btn:hover {
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 22%, #fff);
}

.light-mode .lt-coach-dash__error {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.light-mode .lt-coach-dash__classement-btn {
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
  border-color: rgba(245, 158, 11, 0.35);
}

/* ── Coach bar / chrome ────────────────────────────────────────────────── */

.light-mode .lt-coach-bar-chrome {
  background: var(--lt-glass, rgba(255, 255, 255, 0.94));
  border-color: var(--lt-panel-border, #cbd5e1);
  box-shadow: 0 -4px 18px rgba(15, 23, 42, 0.08);
}

.light-mode .lt-coach-bar__seq-kicker {
  color: var(--lt-fg-muted, #64748b);
}

.light-mode .lt-coach-bar__seq-value {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-coach-bar__btn {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-coach-bar__btn--primary {
  background: var(--lt-brand, #0877bc);
  border-color: transparent;
  color: #fff;
}

.light-mode .lt-coach-bar__btn--danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.light-mode .lt-coach-bar__btn--skip {
  background: #fffbeb;
  border-color: #fde68a;
  color: #b45309;
}

.light-mode .lt-coach-bar__chat-btn {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-coach-bar__error {
  background: #fef2f2;
  color: #b91c1c;
  border-color: #fecaca;
}

/* ── FABs / misc panels ────────────────────────────────────────────────── */

.light-mode .lt-page__fab:not(.lt-page__fab--digiping):not(.lt-page__fab--eval-live) {
  background: var(--lt-panel, #fff);
  border-color: var(--lt-panel-border, #cbd5e1);
  color: var(--lt-fg, #0f172a);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
}

.light-mode .lt-page__kot-hint {
  background: var(--lt-panel, #fff);
  border-color: var(--lt-panel-border, #cbd5e1);
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-return-fab {
  background: var(--lt-panel, #fff);
  border-color: var(--lt-panel-border, #cbd5e1);
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-session-decision,
.light-mode .lt-session-complete,
.light-mode .lt-player-chrono-review {
  background: var(--lt-panel, #fff);
  border-color: var(--lt-panel-border, #cbd5e1);
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-session-complete__title,
.light-mode .lt-session-decision__title {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-session-complete__message,
.light-mode .lt-session-decision__message {
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-session-decision__btn--secondary {
  background: var(--lt-chip-bg, #f1f5f9);
  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-session-complete-overlay {
  background: rgba(241, 245, 249, 0.92);
}

.light-mode .lt-kot-lb {
  background: var(--lt-panel, #fff);
  border-color: color-mix(in srgb, #f59e0b 40%, #cbd5e1);
  color: var(--lt-fg, #0f172a);
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.18);
}

.light-mode .lt-kot-lb__close {
  background: var(--lt-chip-bg, #f1f5f9);
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-kot-lb__backdrop {
  background: rgba(15, 23, 42, 0.4);
}

/* ── Chrono coach panel ────────────────────────────────────────────────── */

.light-mode .lt-chrono-panel__backdrop,
html[data-theme="light"] .lt-chrono-panel__backdrop {
  background: rgba(15, 23, 42, 0.4);
}

.light-mode .lt-chrono-panel,
html[data-theme="light"] .lt-chrono-panel {
  background: linear-gradient(
    165deg,
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 8%, #f8fafc) 0%,
    #ffffff 55%,
    #f1f5f9 100%
  );
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);
  color: var(--lt-fg, #0f172a);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);
}

.light-mode .lt-chrono-panel__header,
.light-mode .lt-chrono-panel__camera-bind,
html[data-theme="light"] .lt-chrono-panel__header,
html[data-theme="light"] .lt-chrono-panel__camera-bind {
  border-color: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-chrono-panel__header h2,
.light-mode .lt-chrono-panel__name,
.light-mode .lt-chrono-panel__clock,
.light-mode .lt-chrono-panel__empty-wrap,
html[data-theme="light"] .lt-chrono-panel__header h2,
html[data-theme="light"] .lt-chrono-panel__name,
html[data-theme="light"] .lt-chrono-panel__clock,
html[data-theme="light"] .lt-chrono-panel__empty-wrap {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-chrono-panel__subtitle,
.light-mode .lt-chrono-panel__camera-label,
.light-mode .lt-chrono-panel__hint,
.light-mode .lt-chrono-panel__empty,
.light-mode .lt-chrono-panel__meta,
.light-mode .lt-chrono-panel__summary,
.light-mode .lt-chrono-panel__video-help,
.light-mode .lt-chrono-panel__video-hint,
.light-mode .lt-chrono-panel__row-hint,
html[data-theme="light"] .lt-chrono-panel__subtitle,
html[data-theme="light"] .lt-chrono-panel__camera-label,
html[data-theme="light"] .lt-chrono-panel__hint,
html[data-theme="light"] .lt-chrono-panel__empty,
html[data-theme="light"] .lt-chrono-panel__meta,
html[data-theme="light"] .lt-chrono-panel__summary,
html[data-theme="light"] .lt-chrono-panel__video-help,
html[data-theme="light"] .lt-chrono-panel__video-hint,
html[data-theme="light"] .lt-chrono-panel__row-hint {
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-chrono-panel__video-hint--ok,
html[data-theme="light"] .lt-chrono-panel__video-hint--ok {
  color: #15803d;
}

.light-mode .lt-chrono-panel__error,
.light-mode .lt-chrono-panel__row-error,
.light-mode .lt-chrono-panel__video-hint--err,
html[data-theme="light"] .lt-chrono-panel__error,
html[data-theme="light"] .lt-chrono-panel__row-error,
html[data-theme="light"] .lt-chrono-panel__video-hint--err {
  color: #b91c1c;
}

.light-mode .lt-chrono-panel__close,
html[data-theme="light"] .lt-chrono-panel__close {
  background: var(--lt-chip-bg, #f1f5f9);
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-chrono-panel__camera-select,
.light-mode .lt-chrono-panel__btn--link-cam,
.light-mode .lt-chrono-panel__btn--reset,
html[data-theme="light"] .lt-chrono-panel__camera-select,
html[data-theme="light"] .lt-chrono-panel__btn--link-cam,
html[data-theme="light"] .lt-chrono-panel__btn--reset {
  background: var(--lt-chip-bg, #f1f5f9);
  border: 1px solid var(--lt-chip-border, rgba(15, 23, 42, 0.14));
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-chrono-panel__btn--link-cam-active,
html[data-theme="light"] .lt-chrono-panel__btn--link-cam-active {
  background: color-mix(in srgb, #16a34a 16%, #fff);
  border-color: color-mix(in srgb, #16a34a 40%, #cbd5e1);
  color: #166534;
}

.light-mode .lt-chrono-panel__btn--review,
html[data-theme="light"] .lt-chrono-panel__btn--review {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, #fff);
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);
  color: var(--lt-brand, #0877bc);
}

.light-mode .lt-chrono-panel__btn--delete,
html[data-theme="light"] .lt-chrono-panel__btn--delete {
  background: color-mix(in srgb, #dc2626 12%, #fff);
  border: 1px solid color-mix(in srgb, #dc2626 35%, #cbd5e1);
  color: #b91c1c;
}

.light-mode .lt-chrono-panel__btn--add-players,
html[data-theme="light"] .lt-chrono-panel__btn--add-players {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);
  color: var(--lt-brand, #0877bc);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);
}

.light-mode .lt-chrono-panel__order,
html[data-theme="light"] .lt-chrono-panel__order {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, #e2e8f0);
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-chrono-panel__row,
html[data-theme="light"] .lt-chrono-panel__row {
  background: #ffffff;
  border-color: rgba(15, 23, 42, 0.12);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.light-mode .lt-chrono-panel__row--running,
html[data-theme="light"] .lt-chrono-panel__row--running {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 50%, #94a3b8);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
}

/* ── Player gamified HUD (bright mode) ─────────────────────────────────── */

.light-mode .lt-pv__screen-awake-chip,
html[data-theme="light"] .lt-pv__screen-awake-chip {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);
  color: var(--lt-brand, #0877bc);
  box-shadow: none;
}

.light-mode .lt-pv__table-panel--gamified,
html[data-theme="light"] .lt-pv__table-panel--gamified {
  background: linear-gradient(
    145deg,
    #ffffff 0%,
    color-mix(in srgb, var(--lt-brand, #0877bc) 6%, #f8fafc) 100%
  );
  border-color: var(--lt-panel-border, #cbd5e1);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.light-mode .lt-pv__stadium-badge,
html[data-theme="light"] .lt-pv__stadium-badge {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);
  box-shadow: none;
}

.light-mode .lt-pv__stadium-label,
html[data-theme="light"] .lt-pv__stadium-label {
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-pv__stadium-num,
html[data-theme="light"] .lt-pv__stadium-num {
  color: var(--lt-brand, #0877bc);
}

.light-mode .lt-pv__matchup-card,
html[data-theme="light"] .lt-pv__matchup-card {
  background: #fff;
  border-color: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-pv__matchup-card--you,
html[data-theme="light"] .lt-pv__matchup-card--you {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  box-shadow: none;
}

.light-mode .lt-pv__player-title,
html[data-theme="light"] .lt-pv__player-title {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-pv__side-tag,
html[data-theme="light"] .lt-pv__side-tag {
  background: rgba(15, 23, 42, 0.06);
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-pv__stat-tag,
html[data-theme="light"] .lt-pv__stat-tag {
  color: var(--lt-fg-muted, #475569);
}

.light-mode .lt-pv__stat-tag--pts,
html[data-theme="light"] .lt-pv__stat-tag--pts {
  color: var(--lt-brand, #0877bc);
}

.light-mode .lt-pv__role-crest--performance,
.light-mode .lt-pv__role-crest--attacker,
html[data-theme="light"] .lt-pv__role-crest--performance,
html[data-theme="light"] .lt-pv__role-crest--attacker {
  background: rgba(34, 179, 92, 0.12);
  border-color: rgba(34, 179, 92, 0.35);
  color: #15803d;
}

.light-mode .lt-pv__role-crest--sparring,
html[data-theme="light"] .lt-pv__role-crest--sparring {
  background: rgba(243, 140, 41, 0.12);
  border-color: rgba(243, 140, 41, 0.35);
  color: #c2410c;
}

.light-mode .lt-pv__matchup-vs-badge,
html[data-theme="light"] .lt-pv__matchup-vs-badge {
  background: #f1f5f9;
  border-color: rgba(15, 23, 42, 0.12);
  color: var(--lt-fg-muted, #64748b);
}

.light-mode .lt-pv__mission-card,
html[data-theme="light"] .lt-pv__mission-card {
  background: #fff;
  border-color: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-pv__mission-lead,
html[data-theme="light"] .lt-pv__mission-lead,
.light-mode .lt-pv__mission-title,
html[data-theme="light"] .lt-pv__mission-title {
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-pv__roster-strip-label,
html[data-theme="light"] .lt-pv__roster-strip-label {
  color: var(--lt-fg-muted, #64748b);
}

.light-mode .lt-pv__roster-pill,
html[data-theme="light"] .lt-pv__roster-pill {
  background: #f1f5f9;
  color: var(--lt-fg, #0f172a);
}

.light-mode .lt-pv__standby-radar,
html[data-theme="light"] .lt-pv__standby-radar {
  background: rgba(251, 191, 36, 0.12);
  border-color: rgba(217, 119, 6, 0.35);
  box-shadow: none;
}

.light-mode .lt-pv__radar-text,
html[data-theme="light"] .lt-pv__radar-text {
  color: #b45309;
}

.light-mode .lt-pv__hr-power-card,
html[data-theme="light"] .lt-pv__hr-power-card {
  background: #fff;
  border-color: rgba(15, 23, 42, 0.1);
  color: var(--lt-fg, #0f172a);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingLightTheme.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,mCAAmC;EACnC,6CAA6C;EAC7C,yCAAyC;EACzC,4EAA4E;EAC5E,qCAAqC;EACrC,qBAAqB;EACrB,wCAAwC;EACxC;;;;;GAKC;EACD,mBAAmB;AACrB;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA,6EAA6E;;AAE7E;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;EAGE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA,6EAA6E;;AAE7E;;;;;;;;;EASE,4BAA4B;AAC9B;;AAEA;;;;;;;;;EASE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;AAC7D;;AAEA;;EAEE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;;;EAGE,iCAAiC;EACjC,iDAAiD;EACjD,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,6EAA6E;;AAE7E;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,kCAAkC;AACpC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,iCAAiC;EACjC,6CAA6C;EAC7C,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;EACvE,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;AACzE;;AAEA;;;;EAIE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;;;;EAIE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA,6EAA6E;;AAE7E;EACE,4BAA4B;AAC9B;;AAEA;EACE,sDAAsD;EACtD,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;AACzE;;AAEA;;EAEE,oCAAoC;EACpC,WAAW;EACX,sCAAsC;AACxC;;AAEA;;EAEE,4EAA4E;EAC5E,iFAAiF;EACjF,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA,6EAA6E;;AAE7E;EACE,sDAAsD;EACtD,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,6EAA6E;;AAE7E;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;;;EAGE,iCAAiC;EACjC,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,sDAAsD;EACtD,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,6EAA6E;;AAE7E;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE;;;;;GAKC;EACD,uEAAuE;EACvE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;;;;;;EAME,sCAAsC;EACtC,+DAA+D;EAC/D,4BAA4B;AAC9B;;AAEA;;EAEE,iDAAiD;EACjD,sDAAsD;EACtD,cAAc;AAChB;;AAEA;;EAEE,kEAAkE;EAClE,2EAA2E;EAC3E,+BAA+B;AACjC;;AAEA;;EAEE,iDAAiD;EACjD,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;;EAEE,kEAAkE;EAClE,+BAA+B;EAC/B,uEAAuE;AACzE;;AAEA;;EAEE,qEAAqE;EACrE,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;;EAEE,uEAAuE;EACvE,kEAAkE;AACpE;;AAEA,6EAA6E;;AAE7E;;EAEE,kEAAkE;EAClE,uEAAuE;EACvE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE;;;;GAIC;EACD,6CAA6C;EAC7C,qFAAqF;AACvF;;AAEA;;EAEE,kEAAkE;EAClE,uEAAuE;EACvE,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,iEAAiE;EACjE,uEAAuE;EACvE,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;EAIE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,mCAAmC;EACnC,4BAA4B;EAC5B,6CAA6C;AAC/C","sourcesContent":["/**\n * Live Training — bright (light) view mode.\n * Aligns page chrome, panels, and typography with global bright UI tokens\n * and the table-setup / coach-table light styles.\n */\n\nhtml.light-mode.lt-immersive body,\nhtml[data-theme=\"light\"].lt-immersive body {\n  background: var(--bg-color, #f3f4f6) !important;\n}\n\n.light-mode .lt-page,\nhtml[data-theme=\"light\"] .lt-page {\n  --lt-fg: var(--text-color, #0f172a);\n  --lt-fg-muted: var(--text-secondary, #475569);\n  --lt-panel: var(--surface-color, #ffffff);\n  --lt-panel-border: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, #cbd5e1);\n  --lt-glass: rgba(255, 255, 255, 0.88);\n  --lt-chip-bg: #f1f5f9;\n  --lt-chip-border: rgba(15, 23, 42, 0.12);\n  background: linear-gradient(\n    165deg,\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 8%, var(--bg-color, #f8fafc)) 0%,\n    var(--bg-color, #f1f5f9) 42%,\n    #ffffff 100%\n  );\n  color: var(--lt-fg);\n}\n\n.light-mode .lt-page__body,\n.light-mode .lt-page__main,\nhtml[data-theme=\"light\"] .lt-page__body,\nhtml[data-theme=\"light\"] .lt-page__main {\n  color: var(--lt-fg, #0f172a);\n}\n\n/* ── Header / progress ─────────────────────────────────────────────────── */\n\n.light-mode .lt-header__title,\n.light-mode .lt-header__sub,\n.light-mode .lt-club-logo-wrap__name {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-header__sub {\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-header__home-btn,\n.light-mode .lt-header__dashboard-btn,\n.light-mode .lt-header__icon-btn {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-progress__meta,\n.light-mode .lt-progress__seg-label {\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-progress__plan-btn {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-progress__track {\n  background: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-progress__seg,\n.light-mode .lt-progress__seg--named {\n  background: rgba(15, 23, 42, 0.08);\n  border-color: transparent;\n}\n\n.light-mode .lt-station-tabs__btn {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-station-tabs__btn--selected {\n  color: #fff;\n}\n\n/* ── Waiting / empty / hero ────────────────────────────────────────────── */\n\n.light-mode .lt-waiting__title,\n.light-mode .lt-waiting__countdown-value,\n.light-mode .lt-waiting__table-num,\n.light-mode .lt-coach-empty__title,\n.light-mode .lt-coach-empty__countdown-value,\n.light-mode .lt-hero__timer-value,\n.light-mode .lt-hero__name,\n.light-mode .lt-hero__number,\n.light-mode .lt-hero__exercise-remaining-value {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-waiting__hint,\n.light-mode .lt-waiting__countdown,\n.light-mode .lt-coach-empty__hint,\n.light-mode .lt-coach-empty__countdown-label,\n.light-mode .lt-hero__timer-state,\n.light-mode .lt-hero__schema,\n.light-mode .lt-hero__exercise-remaining-label,\n.light-mode .lt-hero__matchup,\n.light-mode .lt-hero__table {\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-coach-empty__countdown {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));\n}\n\n.light-mode .lt-coach-empty__btn--secondary,\n.light-mode .lt-coach-empty__btn--ghost {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-waiting__table-card,\n.light-mode .lt-hero__seq-banner,\n.light-mode .lt-hero__exercise-remaining {\n  background: var(--lt-panel, #fff);\n  border: 1px solid var(--lt-panel-border, #cbd5e1);\n  color: var(--lt-fg, #0f172a);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.light-mode .lt-hero__seq-pill {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-hero__ring-bg {\n  stroke: rgba(15, 23, 42, 0.12);\n}\n\n.light-mode .lt-fs-gate {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-mobile-only {\n  background: rgba(255, 255, 255, 0.92);\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-mobile-only__title {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-mobile-only__copy {\n  color: var(--lt-fg-muted, #475569);\n}\n\n/* ── Player view ───────────────────────────────────────────────────────── */\n\n.light-mode .lt-pv,\nhtml[data-theme=\"light\"] .lt-pv {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-pv__chrome,\nhtml[data-theme=\"light\"] .lt-pv__chrome {\n  border-bottom-color: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-pv__player-name,\n.light-mode .lt-pv__id-name,\n.light-mode .lt-pv__table-hero-number,\n.light-mode .lt-pv__table-roster-name,\n.light-mode .lt-pv__timer-value,\n.light-mode .lt-pv__side-chip,\n.light-mode .lt-pv__side-name,\n.light-mode .lt-pv__ls-wait-header-title,\n.light-mode .lt-pv__wait-exercise,\n.light-mode .lt-pv__table-center-number,\nhtml[data-theme=\"light\"] .lt-pv__player-name,\nhtml[data-theme=\"light\"] .lt-pv__id-name,\nhtml[data-theme=\"light\"] .lt-pv__table-hero-number,\nhtml[data-theme=\"light\"] .lt-pv__table-roster-name,\nhtml[data-theme=\"light\"] .lt-pv__timer-value,\nhtml[data-theme=\"light\"] .lt-pv__side-chip,\nhtml[data-theme=\"light\"] .lt-pv__side-name,\nhtml[data-theme=\"light\"] .lt-pv__ls-wait-header-title,\nhtml[data-theme=\"light\"] .lt-pv__wait-exercise,\nhtml[data-theme=\"light\"] .lt-pv__table-center-number {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-pv__table-line,\n.light-mode .lt-pv__table-hero-label,\n.light-mode .lt-pv__table-roster-title,\n.light-mode .lt-pv__personalized-cue,\n.light-mode .lt-pv__timer-label,\n.light-mode .lt-pv__wait-type,\n.light-mode .lt-pv__wait-subtype,\n.light-mode .lt-pv__side-stats,\n.light-mode .lt-pv__table-center-label,\nhtml[data-theme=\"light\"] .lt-pv__table-line,\nhtml[data-theme=\"light\"] .lt-pv__table-hero-label,\nhtml[data-theme=\"light\"] .lt-pv__table-roster-title,\nhtml[data-theme=\"light\"] .lt-pv__personalized-cue,\nhtml[data-theme=\"light\"] .lt-pv__timer-label,\nhtml[data-theme=\"light\"] .lt-pv__wait-type,\nhtml[data-theme=\"light\"] .lt-pv__wait-subtype,\nhtml[data-theme=\"light\"] .lt-pv__side-stats,\nhtml[data-theme=\"light\"] .lt-pv__table-center-label {\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-pv__side-letter,\nhtml[data-theme=\"light\"] .lt-pv__side-letter {\n  color: rgba(15, 23, 42, 0.38);\n}\n\n.light-mode .lt-pv__wait-card,\n.light-mode .lt-pv__table-panel {\n  background: var(--lt-panel, #fff);\n  border-color: var(--lt-panel-border, #cbd5e1);\n  color: var(--lt-fg, #0f172a);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.light-mode .lt-pv__id-bar {\n  border-bottom-color: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-pv__hr-chip,\n.light-mode .lt-panel-mode-toggle {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.12));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-pv__side-chip {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);\n  color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-pv__table-roster-item {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.1));\n}\n\n.light-mode .lt-pv__table-roster-item--viewer {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 30%, #cbd5e1);\n}\n\n.light-mode .lt-pv__role--active,\nhtml[data-theme=\"light\"] .lt-pv__role--active,\n.light-mode .lt-lsp__role--active,\nhtml[data-theme=\"light\"] .lt-lsp__role--active {\n  background: rgba(34, 179, 92, 0.12);\n  color: #15803d;\n  border-color: rgba(34, 179, 92, 0.35);\n}\n\n.light-mode .lt-pv__role--sparring,\nhtml[data-theme=\"light\"] .lt-pv__role--sparring,\n.light-mode .lt-lsp__role--sparring,\nhtml[data-theme=\"light\"] .lt-lsp__role--sparring {\n  background: rgba(243, 140, 41, 0.12);\n  color: #c2410c;\n  border-color: rgba(243, 140, 41, 0.35);\n}\n\n/* ── Coach dashboard ───────────────────────────────────────────────────── */\n\n.light-mode .lt-coach-dash {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-coach-dash__toolbar {\n  background: var(--lt-glass, rgba(255, 255, 255, 0.92));\n  border-color: var(--lt-panel-border, #cbd5e1);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.light-mode .lt-coach-dash__stat,\n.light-mode .lt-coach-dash__chrono-btn {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-coach-dash__chrono-btn {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);\n}\n\n.light-mode .lt-coach-dash__chrono-btn:hover,\n.light-mode .lt-coach-dash__chrono-btn--active {\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  border-color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-coach-dash__tables-btn,\n.light-mode .lt-coach-dash__setup-icon-btn {\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 12%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 35%, #cbd5e1);\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-coach-dash__tables-btn svg,\n.light-mode .lt-coach-dash__setup-icon-btn {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-coach-dash__tables-btn:hover,\n.light-mode .lt-coach-dash__setup-icon-btn:hover {\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 22%, #fff);\n}\n\n.light-mode .lt-coach-dash__error {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.light-mode .lt-coach-dash__classement-btn {\n  background: rgba(245, 158, 11, 0.12);\n  color: #b45309;\n  border-color: rgba(245, 158, 11, 0.35);\n}\n\n/* ── Coach bar / chrome ────────────────────────────────────────────────── */\n\n.light-mode .lt-coach-bar-chrome {\n  background: var(--lt-glass, rgba(255, 255, 255, 0.94));\n  border-color: var(--lt-panel-border, #cbd5e1);\n  box-shadow: 0 -4px 18px rgba(15, 23, 42, 0.08);\n}\n\n.light-mode .lt-coach-bar__seq-kicker {\n  color: var(--lt-fg-muted, #64748b);\n}\n\n.light-mode .lt-coach-bar__seq-value {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-coach-bar__btn {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-coach-bar__btn--primary {\n  background: var(--lt-brand, #0877bc);\n  border-color: transparent;\n  color: #fff;\n}\n\n.light-mode .lt-coach-bar__btn--danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.light-mode .lt-coach-bar__btn--skip {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #b45309;\n}\n\n.light-mode .lt-coach-bar__chat-btn {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-coach-bar__error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border-color: #fecaca;\n}\n\n/* ── FABs / misc panels ────────────────────────────────────────────────── */\n\n.light-mode .lt-page__fab:not(.lt-page__fab--digiping):not(.lt-page__fab--eval-live) {\n  background: var(--lt-panel, #fff);\n  border-color: var(--lt-panel-border, #cbd5e1);\n  color: var(--lt-fg, #0f172a);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);\n}\n\n.light-mode .lt-page__kot-hint {\n  background: var(--lt-panel, #fff);\n  border-color: var(--lt-panel-border, #cbd5e1);\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-return-fab {\n  background: var(--lt-panel, #fff);\n  border-color: var(--lt-panel-border, #cbd5e1);\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-session-decision,\n.light-mode .lt-session-complete,\n.light-mode .lt-player-chrono-review {\n  background: var(--lt-panel, #fff);\n  border-color: var(--lt-panel-border, #cbd5e1);\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-session-complete__title,\n.light-mode .lt-session-decision__title {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-session-complete__message,\n.light-mode .lt-session-decision__message {\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-session-decision__btn--secondary {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border-color: var(--lt-chip-border, rgba(15, 23, 42, 0.14));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-session-complete-overlay {\n  background: rgba(241, 245, 249, 0.92);\n}\n\n.light-mode .lt-kot-lb {\n  background: var(--lt-panel, #fff);\n  border-color: color-mix(in srgb, #f59e0b 40%, #cbd5e1);\n  color: var(--lt-fg, #0f172a);\n  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.18);\n}\n\n.light-mode .lt-kot-lb__close {\n  background: var(--lt-chip-bg, #f1f5f9);\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-kot-lb__backdrop {\n  background: rgba(15, 23, 42, 0.4);\n}\n\n/* ── Chrono coach panel ────────────────────────────────────────────────── */\n\n.light-mode .lt-chrono-panel__backdrop,\nhtml[data-theme=\"light\"] .lt-chrono-panel__backdrop {\n  background: rgba(15, 23, 42, 0.4);\n}\n\n.light-mode .lt-chrono-panel,\nhtml[data-theme=\"light\"] .lt-chrono-panel {\n  background: linear-gradient(\n    165deg,\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 8%, #f8fafc) 0%,\n    #ffffff 55%,\n    #f1f5f9 100%\n  );\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);\n  color: var(--lt-fg, #0f172a);\n  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);\n}\n\n.light-mode .lt-chrono-panel__header,\n.light-mode .lt-chrono-panel__camera-bind,\nhtml[data-theme=\"light\"] .lt-chrono-panel__header,\nhtml[data-theme=\"light\"] .lt-chrono-panel__camera-bind {\n  border-color: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-chrono-panel__header h2,\n.light-mode .lt-chrono-panel__name,\n.light-mode .lt-chrono-panel__clock,\n.light-mode .lt-chrono-panel__empty-wrap,\nhtml[data-theme=\"light\"] .lt-chrono-panel__header h2,\nhtml[data-theme=\"light\"] .lt-chrono-panel__name,\nhtml[data-theme=\"light\"] .lt-chrono-panel__clock,\nhtml[data-theme=\"light\"] .lt-chrono-panel__empty-wrap {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-chrono-panel__subtitle,\n.light-mode .lt-chrono-panel__camera-label,\n.light-mode .lt-chrono-panel__hint,\n.light-mode .lt-chrono-panel__empty,\n.light-mode .lt-chrono-panel__meta,\n.light-mode .lt-chrono-panel__summary,\n.light-mode .lt-chrono-panel__video-help,\n.light-mode .lt-chrono-panel__video-hint,\n.light-mode .lt-chrono-panel__row-hint,\nhtml[data-theme=\"light\"] .lt-chrono-panel__subtitle,\nhtml[data-theme=\"light\"] .lt-chrono-panel__camera-label,\nhtml[data-theme=\"light\"] .lt-chrono-panel__hint,\nhtml[data-theme=\"light\"] .lt-chrono-panel__empty,\nhtml[data-theme=\"light\"] .lt-chrono-panel__meta,\nhtml[data-theme=\"light\"] .lt-chrono-panel__summary,\nhtml[data-theme=\"light\"] .lt-chrono-panel__video-help,\nhtml[data-theme=\"light\"] .lt-chrono-panel__video-hint,\nhtml[data-theme=\"light\"] .lt-chrono-panel__row-hint {\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-chrono-panel__video-hint--ok,\nhtml[data-theme=\"light\"] .lt-chrono-panel__video-hint--ok {\n  color: #15803d;\n}\n\n.light-mode .lt-chrono-panel__error,\n.light-mode .lt-chrono-panel__row-error,\n.light-mode .lt-chrono-panel__video-hint--err,\nhtml[data-theme=\"light\"] .lt-chrono-panel__error,\nhtml[data-theme=\"light\"] .lt-chrono-panel__row-error,\nhtml[data-theme=\"light\"] .lt-chrono-panel__video-hint--err {\n  color: #b91c1c;\n}\n\n.light-mode .lt-chrono-panel__close,\nhtml[data-theme=\"light\"] .lt-chrono-panel__close {\n  background: var(--lt-chip-bg, #f1f5f9);\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-chrono-panel__camera-select,\n.light-mode .lt-chrono-panel__btn--link-cam,\n.light-mode .lt-chrono-panel__btn--reset,\nhtml[data-theme=\"light\"] .lt-chrono-panel__camera-select,\nhtml[data-theme=\"light\"] .lt-chrono-panel__btn--link-cam,\nhtml[data-theme=\"light\"] .lt-chrono-panel__btn--reset {\n  background: var(--lt-chip-bg, #f1f5f9);\n  border: 1px solid var(--lt-chip-border, rgba(15, 23, 42, 0.14));\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-chrono-panel__btn--link-cam-active,\nhtml[data-theme=\"light\"] .lt-chrono-panel__btn--link-cam-active {\n  background: color-mix(in srgb, #16a34a 16%, #fff);\n  border-color: color-mix(in srgb, #16a34a 40%, #cbd5e1);\n  color: #166534;\n}\n\n.light-mode .lt-chrono-panel__btn--review,\nhtml[data-theme=\"light\"] .lt-chrono-panel__btn--review {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, #fff);\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);\n  color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-chrono-panel__btn--delete,\nhtml[data-theme=\"light\"] .lt-chrono-panel__btn--delete {\n  background: color-mix(in srgb, #dc2626 12%, #fff);\n  border: 1px solid color-mix(in srgb, #dc2626 35%, #cbd5e1);\n  color: #b91c1c;\n}\n\n.light-mode .lt-chrono-panel__btn--add-players,\nhtml[data-theme=\"light\"] .lt-chrono-panel__btn--add-players {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);\n  color: var(--lt-brand, #0877bc);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);\n}\n\n.light-mode .lt-chrono-panel__order,\nhtml[data-theme=\"light\"] .lt-chrono-panel__order {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, #e2e8f0);\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-chrono-panel__row,\nhtml[data-theme=\"light\"] .lt-chrono-panel__row {\n  background: #ffffff;\n  border-color: rgba(15, 23, 42, 0.12);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.light-mode .lt-chrono-panel__row--running,\nhtml[data-theme=\"light\"] .lt-chrono-panel__row--running {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 50%, #94a3b8);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n}\n\n/* ── Player gamified HUD (bright mode) ─────────────────────────────────── */\n\n.light-mode .lt-pv__screen-awake-chip,\nhtml[data-theme=\"light\"] .lt-pv__screen-awake-chip {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);\n  color: var(--lt-brand, #0877bc);\n  box-shadow: none;\n}\n\n.light-mode .lt-pv__table-panel--gamified,\nhtml[data-theme=\"light\"] .lt-pv__table-panel--gamified {\n  background: linear-gradient(\n    145deg,\n    #ffffff 0%,\n    color-mix(in srgb, var(--lt-brand, #0877bc) 6%, #f8fafc) 100%\n  );\n  border-color: var(--lt-panel-border, #cbd5e1);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.light-mode .lt-pv__stadium-badge,\nhtml[data-theme=\"light\"] .lt-pv__stadium-badge {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);\n  box-shadow: none;\n}\n\n.light-mode .lt-pv__stadium-label,\nhtml[data-theme=\"light\"] .lt-pv__stadium-label {\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-pv__stadium-num,\nhtml[data-theme=\"light\"] .lt-pv__stadium-num {\n  color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-pv__matchup-card,\nhtml[data-theme=\"light\"] .lt-pv__matchup-card {\n  background: #fff;\n  border-color: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-pv__matchup-card--you,\nhtml[data-theme=\"light\"] .lt-pv__matchup-card--you {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  box-shadow: none;\n}\n\n.light-mode .lt-pv__player-title,\nhtml[data-theme=\"light\"] .lt-pv__player-title {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-pv__side-tag,\nhtml[data-theme=\"light\"] .lt-pv__side-tag {\n  background: rgba(15, 23, 42, 0.06);\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-pv__stat-tag,\nhtml[data-theme=\"light\"] .lt-pv__stat-tag {\n  color: var(--lt-fg-muted, #475569);\n}\n\n.light-mode .lt-pv__stat-tag--pts,\nhtml[data-theme=\"light\"] .lt-pv__stat-tag--pts {\n  color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-pv__role-crest--performance,\n.light-mode .lt-pv__role-crest--attacker,\nhtml[data-theme=\"light\"] .lt-pv__role-crest--performance,\nhtml[data-theme=\"light\"] .lt-pv__role-crest--attacker {\n  background: rgba(34, 179, 92, 0.12);\n  border-color: rgba(34, 179, 92, 0.35);\n  color: #15803d;\n}\n\n.light-mode .lt-pv__role-crest--sparring,\nhtml[data-theme=\"light\"] .lt-pv__role-crest--sparring {\n  background: rgba(243, 140, 41, 0.12);\n  border-color: rgba(243, 140, 41, 0.35);\n  color: #c2410c;\n}\n\n.light-mode .lt-pv__matchup-vs-badge,\nhtml[data-theme=\"light\"] .lt-pv__matchup-vs-badge {\n  background: #f1f5f9;\n  border-color: rgba(15, 23, 42, 0.12);\n  color: var(--lt-fg-muted, #64748b);\n}\n\n.light-mode .lt-pv__mission-card,\nhtml[data-theme=\"light\"] .lt-pv__mission-card {\n  background: #fff;\n  border-color: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-pv__mission-lead,\nhtml[data-theme=\"light\"] .lt-pv__mission-lead,\n.light-mode .lt-pv__mission-title,\nhtml[data-theme=\"light\"] .lt-pv__mission-title {\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-pv__roster-strip-label,\nhtml[data-theme=\"light\"] .lt-pv__roster-strip-label {\n  color: var(--lt-fg-muted, #64748b);\n}\n\n.light-mode .lt-pv__roster-pill,\nhtml[data-theme=\"light\"] .lt-pv__roster-pill {\n  background: #f1f5f9;\n  color: var(--lt-fg, #0f172a);\n}\n\n.light-mode .lt-pv__standby-radar,\nhtml[data-theme=\"light\"] .lt-pv__standby-radar {\n  background: rgba(251, 191, 36, 0.12);\n  border-color: rgba(217, 119, 6, 0.35);\n  box-shadow: none;\n}\n\n.light-mode .lt-pv__radar-text,\nhtml[data-theme=\"light\"] .lt-pv__radar-text {\n  color: #b45309;\n}\n\n.light-mode .lt-pv__hr-power-card,\nhtml[data-theme=\"light\"] .lt-pv__hr-power-card {\n  background: #fff;\n  border-color: rgba(15, 23, 42, 0.1);\n  color: var(--lt-fg, #0f172a);\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
